import { Box, IconButton, Tooltip } from "@mui/material";
import {
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

type SidebarCollapseHandleProps = {
  collapsed: boolean;
  sidebarWidth: number;
  onToggle: () => void;
};

export function SidebarCollapseHandle({
  collapsed,
  sidebarWidth,
  onToggle,
}: SidebarCollapseHandleProps) {
  const { t } = useTranslation();

  const label = collapsed
    ? t("navigation.showSidebar")
    : t("navigation.hideSidebar");

  return (
    <Box
      sx={{
        display: { xs: "none", md: "block" },
        position: "fixed",
        top: "50%",
        left: `${sidebarWidth}px`,
        transform: "translateY(-50%)",
        zIndex: (theme) => theme.zIndex.drawer + 4,
        transition: (theme) =>
          theme.transitions.create("left", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
      }}
    >
      <Tooltip title={label} placement="right">
        <IconButton
          onClick={onToggle}
          aria-label={label}
          size="small"
          sx={{
            width: 22,
            height: 52,
            borderRadius: "0 10px 10px 0",
            border: "1px solid",
            borderLeft: "none",
            borderColor: "divider",
            bgcolor: "background.paper",
            color: "text.secondary",
            boxShadow: 1,
            p: 0,
            "&:hover": {
              bgcolor: "action.hover",
              color: "text.primary",
            },
          }}
        >
          {collapsed ? (
            <KeyboardDoubleArrowRight sx={{ fontSize: "1.1rem" }} />
          ) : (
            <KeyboardDoubleArrowLeft sx={{ fontSize: "1.1rem" }} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
